// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"274":"49d58cb3","835":"681851da"}[chunkId] + ".css";
};